/* global jQuery, ajaxurl, gform_ppcp_pluginsettings_strings */
/* eslint-disable camelcase */

window.GFPPCPSettings = null;

(function ($) {
	const {
		prefixes,
		is_legacy_markup,
	} = gform_ppcp_pluginsettings_strings;

	window.onboardedCallback = async function (authCode, sharedId) {
		const environment = document.querySelectorAll( `[name="${ prefixes.input }environment"]:checked` )[ 0 ].value;

		await fetch(ajaxurl + '?action=gfppcp_onboarding&nonce=' + gform_ppcp_pluginsettings_strings.onboarding_nonce + '&environment=' + environment, {
			method: 'POST',
			headers: {
				'content-type': 'application/json'
			},
			body: JSON.stringify({
				authCode: authCode,
				sharedId: sharedId
			})
		}).then(function (res) {
			if (!res.ok) {
				alert(gform_ppcp_pluginsettings_strings.onboarding_error);
			}

			return res.json();
		}).then(function (res) {
			if (!res.success) {
				alert(res.data.message);
			}
		});
	};

    window.GFPPCPSettings = function () {
        const self = this;

		self.environment = $( `[name="${ prefixes.input }environment"]:checked` ).val();
		self.saveContainer = 'true' === is_legacy_markup
			? $( '#gform-settings-save' ).closest( 'tr' )
			: $( '#tab_gravityformsppcp' ).find( '.gform-settings-save-container' );
		self.button = $( '.gform_ppcp_connect_button' );

		self.init = function() {
			self.initEnvironment();
			self.bindEnvironmentChange();
			self.bindDisconnect();
		};

		self.initEnvironment = function() {
			if ( self.environment === '' || typeof self.environment === 'undefined' ) {
				self.environment = 'live';
				$( '#environment0' ).prop( 'checked', true );
			}

			self.environmentChange( self.environment );
		};

		self.bindEnvironmentChange = function() {
			// Bind action urls.
			self.setActionUrl( 'live' );
			self.setActionUrl( 'sandbox' );

			self.environmentChange( self.environment );

			// Switch PayPal Connect button between live and sandbox mode.
			$( `#tab_gravityformsppcp input[name="${ prefixes.input }environment"]` ).on( 'change', function() {
				self.environment = $( this ).val();

				self.environmentChange( self.environment );
				self.toggleSettingsSave();
			} );
		};

		self.toggleSettingsSave = function() {
			if ( $( `#${ prefixes.field }${ self.environment }_auth_button .gform_ppcp_disconnect_button` ).length ) {
				self.saveContainer.fadeIn();
			} else {
				self.saveContainer.fadeOut();
			}
		};

		self.environmentChange = function( environment ) {
			const hideEnv = ( environment === 'live' ) ? 'sandbox' : 'live';

			// display the PayPal Connect button and status in corresponding mode.
			$( `#${ prefixes.field }${ hideEnv }_auth_button, #${ prefixes.field }${ hideEnv }_account_status, #${ prefixes.field }${ environment }_account_status` ).hide();
			$( `#${ prefixes.field }${ environment }_auth_button` ).show();

			const $accountStatus = $( `#${ prefixes.field }${ environment }_account_status` );

			const $connected = 'true' === is_legacy_markup
				? $accountStatus.find( 'td' )
				: $accountStatus.find( 'p' );

			if ( $connected.length && $connected.html().trim() !== '' ) {
				$accountStatus.show();
			}
		};

		self.setActionUrl = function( environment ) {
			const actionUrl = ( environment === 'live' ) ? gform_ppcp_pluginsettings_strings.live_action_url : gform_ppcp_pluginsettings_strings.sandbox_action_url;

			$( `#${ prefixes.field }${ environment }_auth_button .gform_ppcp_connect_button` ).attr( 'href', `${ actionUrl }&displayMode=minibrowser` );
		};

        self.bindDisconnect = function () {
            $('.gform_ppcp_disconnect_button').on('click', function (e) {
                e.preventDefault();

                const disconnectMessage = gform_ppcp_pluginsettings_strings.disconnect;
                const button = $(this);

                // Confirm disconnection.
                if (!confirm(disconnectMessage['site'])) {
                    return false;
                }

                // Set disabled state.
                button.attr('disabled', 'disabled');

                // Disconnect.
                $.ajax({
                    async: false,
                    url: ajaxurl,
                    dataType: 'json',
                    method: 'POST',
                    data: {
                        action: 'gfppcp_disconnect',
                        environment: self.environment,
                        nonce: gform_ppcp_pluginsettings_strings.disconnect_nonce
                    },
                    success: function (response) {
                        if (response.success) {
                            window.location.reload();
                        } else {
                            alert(response.data.message);
                            button.removeAttr('disabled');
                        }
                    }
                });
            });
        };

        self.init();
    };

    $(document).ready(GFPPCPSettings);
})(jQuery);
